// Module
var code = "<meets-redirect></meets-redirect>";
// Exports
module.exports = code;